/* ===========================================================================
   Canvas size pills (snippets/cv-sizes.liquid)
   ---------------------------------------------------------------------------
   Selecting a size updates that card's price and points its Add to cart form
   at the chosen variant. The form is found inside the same canvas stage by
   the variant id it currently carries, so this works for the generated grid
   cards and the ritual bands alike without knowing their markup.
   Loaded once per band; guarded so it initialises only once.
   ========================================================================= */
(function () {
  "use strict";
  if (window.__ddcSizes) return;
  window.__ddcSizes = true;

  function formsFor(row) {
    var ids = (row.getAttribute("data-variant-ids") || "").split(",").filter(Boolean);
    var stage = row.closest(".ddc-cv__stage") || document;
    return Array.prototype.filter.call(stage.querySelectorAll("form"), function (f) {
      var input = f.querySelector('input[name="id"]');
      return input && ids.indexOf(input.value) !== -1;
    });
  }

  function select(row, pill) {
    Array.prototype.forEach.call(row.querySelectorAll(".ddc-szp"), function (p) {
      var on = p === pill;
      p.classList.toggle("is-active", on);
      p.setAttribute("aria-checked", on ? "true" : "false");
    });
    var group = row.getAttribute("data-size-group");
    var price = document.querySelector('[data-size-price="' + group + '"]');
    if (price) price.textContent = pill.getAttribute("data-price");
    var sold = pill.getAttribute("data-available") !== "true";
    formsFor(row).forEach(function (f) {
      f.querySelector('input[name="id"]').value = pill.getAttribute("data-variant");
      var btn = f.querySelector('button[type="submit"]');
      if (btn) btn.disabled = sold;
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-size-group]"), function (row) {
      var active = row.querySelector(".ddc-szp.is-active") || row.querySelector(".ddc-szp");
      if (active) select(row, active); // forms may still carry a hidden size
    });
  }

  document.addEventListener("click", function (e) {
    var pill = e.target.closest && e.target.closest(".ddc-szp");
    if (!pill) return;
    var row = pill.closest("[data-size-group]");
    if (row) select(row, pill);
  });

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  window.addEventListener("pageshow", init);
})();
